import React from 'react';

const PROMO_ITEMS = [
  { icon: '🚚', text: <>Fast &amp; affordable <strong className="text-white font-bold">doorstep shipping</strong> across <strong className="text-yellow-300 font-bold">all 19,000+ pincodes!</strong></> },
  { icon: '⚡', text: <>Same Day Printing — <strong className="text-white font-bold">order before 2 PM</strong></> },
  { icon: '📦', text: <>3–7 day doorstep delivery <strong className="text-white font-bold">all over INDIA 🇮🇳</strong></> },
  { icon: '📚', text: <>Print from just <strong className="text-yellow-300 font-bold font-mono">₹0.89/page</strong> with <strong className="text-white font-bold">Community Passes</strong></> },
  { icon: '💎', text: <>First order? Get <strong className="text-white font-bold">Diamond pricing</strong> automatically!</> },
];

const Dot = () => (
  <span className="inline-block mx-4 w-1 h-1 rounded-full bg-white/50 align-middle" />
);

export default function TopPromoStrips() {
  return (
    <div className="w-full select-none z-50">
      {/* ── 1. Top Trust Strip (Jet Black): Govt Registration, Udyam & GSTIN ── */}
      <div
        data-keep-white="true"
        className="w-full bg-[#000000] border-b border-white/10 text-white/90 py-1.5 px-3 sm:px-6 lg:px-8 text-[11px] sm:text-xs tracking-wide select-none shadow-sm overflow-hidden"
        style={{ backgroundColor: '#000000', color: '#E4E4E7' }}
      >
        {/* Desktop View: Left End & Right End Aligned */}
        <div className="hidden sm:flex max-w-7xl mx-auto items-center justify-between w-full">
          {/* Left End */}
          <div className="flex items-center gap-2.5 text-zinc-300 font-medium">
            <span className="flex items-center gap-1.5">
              <span>🏛️</span>
              <span className="text-white font-semibold">Govt. Registered</span>
            </span>
            <span className="text-white/30">•</span>
            <span className="text-zinc-200 font-medium">
              GST Registered
            </span>
            <span className="text-white/30">•</span>
            <span className="text-zinc-200 font-medium">
              Udyam Certified
            </span>
          </div>

          {/* Right End */}
          <div className="flex items-center gap-2">
            <span className="text-zinc-400 font-medium">GSTIN:</span>
            <span className="font-mono font-semibold tracking-wider text-white bg-white/[0.08] px-2.5 py-0.5 rounded text-[11px] border border-white/15 shadow-xs">
              10KZYPK3952E1Z0
            </span>
          </div>
        </div>

        {/* Mobile View: Continuous Smooth Left-to-Right Loop */}
        <div className="flex sm:hidden w-full overflow-hidden">
          <div
            className="flex w-max"
            style={{
              animation: 'marquee-left-to-right 22s linear infinite',
              willChange: 'transform',
            }}
          >
            {/* Copy 1 */}
            <div className="flex items-center gap-2.5 whitespace-nowrap pr-4 text-zinc-300">
              <span className="flex items-center gap-1.5">
                <span>🏛️</span>
                <span className="text-white font-semibold">Govt. Registered</span>
              </span>
              <span className="text-white/30">•</span>
              <span className="text-zinc-200 font-medium">GST Registered</span>
              <span className="text-white/30">•</span>
              <span className="text-zinc-200 font-medium">Udyam Certified</span>
              <span className="text-white/30">•</span>
              <span className="inline-flex items-center gap-1">
                <span className="text-zinc-400">GSTIN:</span>
                <span className="font-mono font-semibold text-white bg-white/[0.08] px-1.5 py-0.5 rounded text-[10px] border border-white/15">
                  10KZYPK3952E1Z0
                </span>
              </span>
              <span className="text-white/30 mx-1">•</span>
            </div>

            {/* Copy 2 for seamless loop */}
            <div className="flex items-center gap-2.5 whitespace-nowrap pr-4 text-zinc-300">
              <span className="flex items-center gap-1.5">
                <span>🏛️</span>
                <span className="text-white font-semibold">Govt. Registered</span>
              </span>
              <span className="text-white/30">•</span>
              <span className="text-zinc-200 font-medium">GST Registered</span>
              <span className="text-white/30">•</span>
              <span className="text-zinc-200 font-medium">Udyam Certified</span>
              <span className="text-white/30">•</span>
              <span className="inline-flex items-center gap-1">
                <span className="text-zinc-400">GSTIN:</span>
                <span className="font-mono font-semibold text-white bg-white/[0.08] px-1.5 py-0.5 rounded text-[10px] border border-white/15">
                  10KZYPK3952E1Z0
                </span>
              </span>
              <span className="text-white/30 mx-1">•</span>
            </div>
          </div>
        </div>
      </div>

      {/* ── 2. Promo Strip: Continuous right-to-left marquee ── */}
      <div className="w-full overflow-hidden">
        <div
          data-keep-white="true"
          className="promo-marquee-strip relative w-full overflow-hidden py-[7px] text-[11px] sm:text-xs font-semibold text-white tracking-wide select-none"
          style={{
            color: '#FFFFFF',
            background: 'linear-gradient(90deg, #7c3aed 0%, #4f46e5 40%, #7c3aed 75%, #4f46e5 100%)',
            backgroundSize: '200% 100%',
            animation: 'promoShimmer 4s linear infinite',
          }}
        >
          {/* Shimmer sweep */}
          <span
            className="pointer-events-none absolute inset-0 z-10"
            style={{
              background: 'linear-gradient(105deg, transparent 30%, rgba(255,255,255,0.07) 50%, transparent 70%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 3s infinite',
            }}
          />

          {/* Marquee track — duplicated for seamless loop */}
          <div className="flex w-max" style={{ animation: 'marqueeRTL 28s linear infinite' }}>
            {/* First copy */}
            <div className="flex items-center whitespace-nowrap">
              {PROMO_ITEMS.map((item, i) => (
                <React.Fragment key={`a-${i}`}>
                  <span className="flex items-center gap-1.5">
                    <span className="text-sm">{item.icon}</span>
                    <span>{item.text}</span>
                  </span>
                  <Dot />
                </React.Fragment>
              ))}
            </div>
            {/* Duplicate for seamless loop */}
            <div className="flex items-center whitespace-nowrap">
              {PROMO_ITEMS.map((item, i) => (
                <React.Fragment key={`b-${i}`}>
                  <span className="flex items-center gap-1.5">
                    <span className="text-sm">{item.icon}</span>
                    <span>{item.text}</span>
                  </span>
                  <Dot />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
